import { SpinnerStyle } from "src/features/product-modal/style/ProductModal.style";
import styled from "styled-components";

interface StyleProps {
  $isLoading: boolean;
}

export const DivCombinedProductCard = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  position: relative;

  & {
    .akn-combined-modal-details {
      padding: 18px;
      display: flex;
      flex-direction: column;
      background: #fff;
      flex-grow: 1;
      justify-content: space-between;
    }
  }

  ${({ $isLoading }) => $isLoading && SpinnerStyle}
`;
